export const isJSON: (text: string) => boolean = (text) => {
  if (typeof text !== 'string') {
    return false;
  }
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export function getUserDataFromCookie() {
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');

  const userDataCookie = cookies.find((cookie) =>
    cookie.trim().startsWith('userData=')
  );

  if (userDataCookie) {
    const userDataString = userDataCookie.split('=')[1];
    try {
      const userData = JSON.parse(decodeURIComponent(userDataString));
      return userData;
    } catch (error) {
      console.error('Error parsing userData cookie:', error);
      return null;
    }
  } else {
    return null;
  }
}
